import { FieldSet, FormHelp, Heading, Label, LabeledControl, Legend, Radio } from '@zillow/constellation-10';
import { Controller, useFormContext } from 'react-hook-form';
import { isValidNonNull } from '../../../../utils/validation';

export function SmokingStep() {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Heading level={2} textStyle="heading-sm" css={{ marginBottom: 'default', fontFamily: 'heading-alt' }}>
        Smoking
      </Heading>
      <Controller
        name="isSmoker"
        rules={{ validate: isValidNonNull }}
        render={({ field: { onChange, value, onBlur } }) => (
          <FieldSet
            legend={<Legend>Does anyone in the household smoke?</Legend>}
            description={errors.isSmoker?.message ? <FormHelp>{String(errors.isSmoker.message)}</FormHelp> : undefined}
            error={!!errors.isSmoker}
            onBlur={onBlur}
          >
            <LabeledControl
              onChange={() => onChange(true)}
              label={<Label>Yes</Label>}
              control={<Radio name="isSmoker" defaultChecked={value === true} />}
            />
            <LabeledControl
              onChange={() => onChange(false)}
              label={<Label>No</Label>}
              control={<Radio name="isSmoker" defaultChecked={value === false} />}
            />
          </FieldSet>
        )}
      />
    </>
  );
}
